import { c as _c } from "react/compiler-runtime";
import { useQueries } from "@tanstack/react-query";
import { useWaveOutcomesQuery } from "./useWaveOutcomesQuery";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
import { ApiWaveOutcomeType } from "@/generated/models/ApiWaveOutcomeType";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiWaveOutcomeDistributionItemsPage } from "@/generated/models/ApiWaveOutcomeDistributionItemsPage";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const DISTRIBUTION_PAGE_SIZE = 100;
interface WaveRankRewards {
  readonly nicTotal: number;
  readonly repTotal: number;
  readonly manualOutcomes: string[];
  readonly isLoading: boolean;
}
export function useWaveRankReward(t0) {
  const $ = _c(32);
  const {
    waveId,
    rank,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const t2 = enabled && !!rank;
  let t3;
  if ($[0] !== t2 || $[1] !== waveId) {
    t3 = {
      waveId,
      enabled: t2
    };
    $[0] = t2;
    $[1] = waveId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    outcomes,
    isEnabled: isOutcomesEnabled
  } = useWaveOutcomesQuery(t3);
  const targetIndex = rank ? rank - 1 : 0;
  const page = Math.floor(targetIndex / DISTRIBUTION_PAGE_SIZE) + 1;
  let t4;
  if ($[3] !== enabled || $[4] !== isOutcomesEnabled || $[5] !== outcomes || $[6] !== page || $[7] !== rank || $[8] !== waveId) {
    let t5;
    if ($[10] !== enabled || $[11] !== isOutcomesEnabled || $[12] !== page || $[13] !== rank || $[14] !== waveId) {
      t5 = outcome => ({
        queryKey: [QueryKey.WAVE_OUTCOME_DISTRIBUTION_PAGE, waveId, outcome.index, page, DISTRIBUTION_PAGE_SIZE],
        queryFn: () => commonApiFetch({
          endpoint: `waves/${waveId}/outcomes/${outcome.index}/distribution`,
          params: {
            page: page.toString(),
            page_size: DISTRIBUTION_PAGE_SIZE.toString()
          }
        }),
        enabled: isOutcomesEnabled && !!rank && enabled,
        staleTime: 60000
      });
      $[10] = enabled;
      $[11] = isOutcomesEnabled;
      $[12] = page;
      $[13] = rank;
      $[14] = waveId;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = outcomes.map(t5);
    $[3] = enabled;
    $[4] = isOutcomesEnabled;
    $[5] = outcomes;
    $[6] = page;
    $[7] = rank;
    $[8] = waveId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = {
      queries: t4
    };
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const distributionQueries = useQueries(t5);
  let t6;
  if ($[18] !== distributionQueries) {
    t6 = distributionQueries.some(_temp);
    $[18] = distributionQueries;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const isLoading = t6;
  if (!rank || !enabled) {
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        nicTotal: 0,
        repTotal: 0,
        manualOutcomes: [],
        isLoading: false
      };
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    return t7;
  }
  let manualOutcomes;
  let nicTotal;
  let repTotal;
  if ($[21] !== distributionQueries || $[22] !== outcomes || $[23] !== targetIndex) {
    nicTotal = 0;
    repTotal = 0;
    manualOutcomes = [];
    outcomes.forEach((outcome_0, i) => {
      const query = distributionQueries[i];
      if (query?.data?.data) {
        const item = query.data.data.find(d => d.index - 1 === targetIndex);
        if (item?.amount) {
          if (outcome_0.credit === ApiWaveOutcomeCredit.Cic) {
            nicTotal = nicTotal + item.amount;
            nicTotal;
          } else {
            if (outcome_0.credit === ApiWaveOutcomeCredit.Rep) {
              repTotal = repTotal + item.amount;
              repTotal;
            } else {
              if (outcome_0.type === ApiWaveOutcomeType.Manual && item.description) {
                manualOutcomes.push(item.description);
              }
            }
          }
        }
      }
    });
    $[21] = distributionQueries;
    $[22] = outcomes;
    $[23] = targetIndex;
    $[24] = manualOutcomes;
    $[25] = nicTotal;
    $[26] = repTotal;
  } else {
    manualOutcomes = $[24];
    nicTotal = $[25];
    repTotal = $[26];
  }
  let t7;
  if ($[27] !== isLoading || $[28] !== manualOutcomes || $[29] !== nicTotal || $[30] !== repTotal) {
    t7 = {
      nicTotal,
      repTotal,
      manualOutcomes,
      isLoading
    };
    $[27] = isLoading;
    $[28] = manualOutcomes;
    $[29] = nicTotal;
    $[30] = repTotal;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}
function _temp(q) {
  return q.isLoading;
}